import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            w: '100%',
            textAlign: 'center',
            py: {base: 'medium.base', xl: 'medium.lg'},
        },
        content: {
            maxW: {base: '100%', xl: remCalc(1400)},
            mx: {base: 0, xl: 'auto'},
            position: 'relative',

            '.product-moodboard-swiper': {
                display: {md: 'flex'},
                overflow: 'hidden',
            },
            '.product-moodboard-pagination.swiper-pagination-bullets.swiper-pagination-horizontal':
                {
                    width: 'fit-content',
                    maxWidth: '100%',
                    left: 'auto',
                    right: 'auto',
                    marginInline: 'auto',
                    flexWrap: 'nowrap',
                },
            '.product-moodboard-pagination .swiper-pagination-bullet': {
                minHeight: remCalc(28),
                width: 'auto',
                height: 'auto',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1,
                borderRadius: 'full',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'transparent',
                background: 'transparent',
                color: 'text.light',
                paddingInline: remCalc(12),
                margin: '0 !important',
                opacity: 1,
                cursor: 'pointer',
                boxSizing: 'border-box',
                whiteSpace: 'nowrap',
            },

            '.product-moodboard-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active':
                {
                    border: 'small',
                    borderStyle: 'solid',
                    borderColor: 'border.neutral.highlight',
                    boxShadow: 'borderShadow',
                    background: 'background.strong.default',
                    color: 'foreground.neutral.inverse',
                },

            '.product-moodboard-pagination .swiper-pagination-bullet:hover': {
                background: 'background.strong.default',
                color: 'foreground.neutral.inverse',
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                w: 'auto',
                h: 'auto',
                m: 0,
                cursor: 'pointer',
            },

            '.img-container:hover img': {
                transform: 'scale(1.2)',
            },
        },
        pagination: {
            justifyContent: 'center',
            zIndex: 1,
            display: 'inline-flex',
            width: 'fit-content',
            maxWidth: '100%',
            marginInline: 'auto',
            flexWrap: 'nowrap',
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.light',
            mb: remCalc(24),
            gap: remCalc(8),
            bg: 'background.base.deep',
            borderRadius: 'full',
            py: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            px: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
        },
        heroLeftRightArrowsContainer: {
            position: 'absolute',
            zIndex: 10,
            display: 'flex',
            height: remCalc(36),
            alignItems: 'center',
            justifyContent: 'center',
            color: 'foreground.neutral.inverse',
            borderRadius: 'full',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            width: remCalc(36),
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            transform: 'translateY(-50%)',
        },
        heroLeftRightArrows: {
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: remCalc(16),
            userSelect: 'none',
            color: 'foreground.neutral.inverse',
            _after: {
                content: 'none',
                display: 'none',
            },
        },
        boardcontainer: {
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
            alignSelf: 'stretch',
        },
        boardfirsthalf: {
            flexDirection: 'column',
            alignSelf: 'stretch',
            flex: '50%',
        },
        boardsecondhalf: {
            direction: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
            alignSelf: 'stretch',
            flex: '50%',
        },
        boardtwoboxcontainer: {
            alignItems: 'flex-start',
            flexGrow: 1,
            alignSelf: 'stretch',
            gap: {base: remCalc(8), md: remCalc(16), lg: remCalc(24)},
        },
        productbox: {
            flexDirection: 'column',
            alignSelf: 'stretch',
            flexGrow: 1,
            justifyContent: 'flex-start',
            alignItems: 'center',
            bg: 'background.light',
            overflow: 'hidden',
            py: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            gap: {base: remCalc(8), md: remCalc(16)},
        },
        imagecontainer: {
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 'large-1',
        },
        imageoverlay: {
            backgroundColor: 'background.base.overlay',
            opacity: 0.055,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        image: {
            w: {base: remCalc(311), md: remCalc(250), lg: remCalc(310), xl: remCalc(440)},
            h: {base: remCalc(250), md: remCalc(250), lg: remCalc(295), xl: remCalc(440)},
            transition: 'transform 0.7s ease-in-out',
            borderRadius: 'large-1',
            mixBlendMode: 'multiply',
        },
        textbox: {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        productId: {
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: 'foreground.neutral.subtle',
            pb: remCalc(4),
        },
        productName: {
            textStyle: 'body-large',
            fontWeight: 'bold',
            pb: remCalc(8),
        },
        price: {
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        omnibusPrice: {
            maxW: '100%',
            mt: remCalc(4),
        },
    },
    variants: {
        mediumTile: {
            productbox: {
                flexDirection: 'row',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                py: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
                px: {base: remCalc(16), md: remCalc(40), lg: remCalc(40)},
            },
            imagecontainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                flex: '50%',
                bg: 'background.base.default',
                borderRadius: 'large-1',
            },
            image: {
                w: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
                h: {base: remCalc(130), md: remCalc(130), lg: remCalc(178), xl: remCalc(266)},
            },
            textbox: {
                alignSelf: 'stretch',
                flex: '50%',
            },
        },
        smallTile: {
            productbox: {
                flex: '50%',
                gap: {base: remCalc(8), md: remCalc(8)},
                py: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
                px: {base: remCalc(16), md: remCalc(16), lg: remCalc(16)},
            },
            image: {
                w: {base: remCalc(130), md: remCalc(130), lg: remCalc(110), xl: remCalc(164)},
                h: {base: remCalc(130), md: remCalc(130), lg: remCalc(100), xl: remCalc(164)},
            },
        },
    },
    parts: ['productbox', 'image', 'imagecontainer', 'textbox'],
}
